(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["stock-indicator"] && !Shopify.designMode) return;
  try {
    (function(){
  function selectedOpts(scope){
    var o=[], fs=scope.querySelectorAll('fieldset');
    if(fs.length){ fs.forEach(function(f){ var c=f.querySelector('input:checked'); if(c) o.push(c.value.trim()); }); }
    else { scope.querySelectorAll('select').forEach(function(s){ o.push(s.value.trim()); }); }
    return o;
  }
  function update(){
    var el=document.querySelector('[data-stock-indicator]'); if(!el) return;
    var sc=document.querySelector('script[data-stock-data]'); if(!sc) return;
    var variants; try{ variants=JSON.parse(sc.textContent); }catch(e){ return; }
    var low=parseInt(el.getAttribute('data-low'),10)||5;
    var scope=el.closest('product-info')||document;
    var sel=selectedOpts(scope); if(!sel.length) return;
    var v=variants.find(function(x){ return (x.opts||[]).map(String).join('\u241F')===sel.join('\u241F'); });
    if(!v) return;
    var cls,txt;
    if(!v.available){ cls='out'; txt='Agotado'; }
    else if(v.qty!==null && v.qty>0 && v.qty<=low){ cls='low'; txt='Últimas piezas'; }
    else { cls='in'; txt='En stock'; }
    el.className='stock-indicator stock-indicator--'+cls;
    el.innerHTML='<span class="stock-dot"></span>'+txt;
  }
  document.addEventListener('change', function(e){ if(e.target && e.target.matches && e.target.matches('input,select')) setTimeout(update,50); });
  document.addEventListener('DOMContentLoaded', update);
  document.addEventListener('shopify:section:load', update);
})();
  } catch(e) { console.error(e); }
})();

})();
